<template>
  <div class="download-page" v-title data-title="彬途教育APP下载">
    <header class="g-header-container">
      <div class="g-navbar">
        <h1 class="g-navbar-title">
          <span class="g-navbar-text">彬途教育APP下载</span>
        </h1>
      </div>
    </header>
    <main class="g-view-container">
      <c-slider>
        <template v-for="(item, index) in details">
          <swiper-slide :key="index">
            <img class="detail" :src="item" />
          </swiper-slide>
        </template>
      </c-slider>
      <div class="content">
        <h2 class="title">彬途教育APP，让学习变得更有计划！</h2>
        <div class="btn-download" @click="download">点击下载APP</div>
      </div>

      <div class="footer">
        <p class="text">Copyright © 彬途教育</p>
      </div>
    </main>
  </div>
</template>

<script>
  import CSlider from 'base/slider';
  import judgeClient from 'assets/js/judgeClient';
  import { bt } from '../config';

  export default {
    name: 'btDownload',
    components: {
      CSlider,
    },
    created() {
      this.details = bt.detail;
    },
    methods: {
      download() {
        const ua = judgeClient();
        if (ua === 'Android') {
          window.location.href = bt.androidUrl;
        } else if (ua === 'iOS') {
          this.$toast('暂未开放');
        } else {
          this.$toast('请用手机打开');
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
@import "~assets/scss/mixins";

.g-view-container {
  position: relative;
  padding-bottom: 16px;
  @include flex-between(column);
}

.swiper-container {
  width: 100%;

  .detail {
    width: 100%;
  }

  ::v-deep .swiper-pagination {
    bottom: -1px;
  }
}

.content {
  margin-top: 10px;
  width: 100%;
  flex: 1;

  .title {
    font-size: 14px;
    color: #333;
    text-align: center;
    line-height: 3;
  }

  .btn-download {
    margin: 0 auto;
    width: 90%;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    letter-spacing: 1px;
    color: #fff;
    text-align: center;
    background: linear-gradient(to right bottom, #5538de, #a838de);
    border-radius: 4px;
  }
}

.footer {
  text-align: center;
  line-height: 1.75;

  .link {
    color: #576b95;
  }

  .text {
    color: rgba(0, 0, 0, 0.3);
  }
}

::v-deep .swiper-pagination-bullet-active {
  background-color: #5538de;
}
</style>
